import axios from 'axios'

export default () => {
    let ax = axios.create({
        baseURL: "http://localhost:5557", //https://host.docker.internal:5557
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
            "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token"
        }
    })
    ax.interceptors.response.use((response) => {
        return response
    }, (error) => {
        return error.response
    })
    return ax
}
